export default __webpack_public_path__ + "static/media/floorplan.78b68eeb.svg";